function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import PDFViewer from '../PDFViewer';
import { fallbackPatterns, useFileName } from './useFileName';
import MobilePDFActions from './MobilePDFActions';
import OnLoadFileError from './OnLoadFileError';
import styles from './PDFSubpageWrapper.pcss';
const PDFSubpageWrapper = ({ module })=>{
    useStyles(styles);
    const [patternIndex, setPatternIndex] = useState(0);
    const [noFileError, setNoFileError] = useState(false);
    const onSetIndex = ()=>{
        setPatternIndex(patternIndex + 1);
    };
    const onLoadFileError = ()=>{
        if (patternIndex + 1 < fallbackPatterns) {
            setPatternIndex(patternIndex + 1);
        }
    };
    useEffect(()=>{
        if (patternIndex === fallbackPatterns) {
            setNoFileError(true);
        }
    }, [
        patternIndex
    ]);
    const fileUrl = useFileName(module.DIR, module.FILENAME_PATTERN, patternIndex, onSetIndex);
    const childProps = {
        fileUrl,
        CustomActions: MobilePDFActions,
        onLoadError: onLoadFileError
    };
    return noFileError || patternIndex === fallbackPatterns ? /*#__PURE__*/ _jsx(OnLoadFileError, {}) : /*#__PURE__*/ _jsx(PDFViewer, _object_spread({}, childProps));
};
export default PDFSubpageWrapper;
